module.exports = __webpack_public_path__ + "static/video-6ca95c368b3d7484de8fbfbb87eba92c.mp4";